import { render, staticRenderFns } from "./DerbyLeagueForm.vue?vue&type=template&id=d28b2872&scoped=true&"
import script from "./DerbyLeagueForm.vue?vue&type=script&lang=js&"
export * from "./DerbyLeagueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28b2872",
  null
  
)

export default component.exports